module.exports = __webpack_public_path__ + "img/pic-jiao.9063e083.png";